// The 14 real sections behind Prompt Hub's new left-nav + right-panel layout, grouped the same
// way the approved mockup grouped them. Each section's `fields` list is the set of FormData keys
// (exactly the keys PAuthQOnBoardingForm.js's old single handleSubmit used to send ALL of, every
// time) that THIS section's own "Save" button sends - every other key is simply omitted, which is
// safe now that the backend (/api/PAuthQOnBoardingTemplate) merges an omitted field against the
// current row instead of wiping it.
//
// "knowledgeBase" has no `fields` here on purpose: it already saves through its own dedicated
// endpoints (handleKbUsagePromptSave, upload/delete) and was never part of the monolithic
// handleSubmit payload - its section in the new layout just keeps calling those.
//
// "review" intentionally lists every field from every other section: it's the renamed equivalent
// of today's final "Publish" action, the one case that's still meant to send everything and run
// every section's validator, not a partial save.
const SETUP_FIELDS = ["providerName", "providerFacilityName", "providerContactNumber", "promptFile"];
const BUSINESS_HOURS_FIELDS = ["selectedTimezone", "businessHours"];
const MULTI_AGENT_FIELDS = ["agentConfigs"];
const GREETING_FIELDS = ["firstMessage", "lastMessage", "greetingInterruptible"];
const IVR_FIELDS = ["ivrMenu"];
const CALL_BEHAVIOR_FIELDS = ["backgroundNoise", "sipTerminationDynamicSeconds", "transferSipTerminationDynamicSeconds", "status"];
const LANGUAGES_FIELDS = ["selectedLanguages"];
const SUMMARY_PARAMS_FIELDS = ["parameters"];
// "reasoning" is one combined key (not separate thinkingEnabled/reasoningEffort keys) because
// both values come out of a single normalizeReasoningSelection(selectedModal, ...) call - two
// separate field keys would run that call twice and append each backend field twice. Same reason
// "caching" is one key covering both CacheEnabled and CacheTTL.
const MODEL_REASONING_FIELDS = ["selectedModal", "reasoning"];
const CACHING_FIELDS = ["caching"];
const TURN_DETECTION_FIELDS = ["turnDetectionMode", "eouMinDelay", "eouMaxDelay"];
const VOICE_SPEECH_FIELDS = ["selectedVoice", "selectedVoiceModal", "sttProvider", "selectedSttModel", "fluxKeyterms", "elevenLabsTtsModel"];

export const PROMPT_HUB_SECTIONS = [
  { id: "basicInfo", category: "Setup", label: "Basic Info", fields: SETUP_FIELDS },
  { id: "businessHours", category: "Setup", label: "Business Hours", fields: BUSINESS_HOURS_FIELDS },
  { id: "multiAgent", category: "Setup", label: "Multi-Agent Setup", fields: MULTI_AGENT_FIELDS },
  { id: "greeting", category: "Conversation", label: "Greeting & Messages", fields: GREETING_FIELDS },
  { id: "ivr", category: "Conversation", label: "IVR Menu", fields: IVR_FIELDS },
  { id: "callBehavior", category: "Conversation", label: "Call Behavior", fields: CALL_BEHAVIOR_FIELDS },
  { id: "languages", category: "Conversation", label: "Languages", fields: LANGUAGES_FIELDS },
  { id: "summaryParams", category: "Conversation", label: "Summary Parameters", fields: SUMMARY_PARAMS_FIELDS },
  { id: "modelReasoning", category: "Intelligence", label: "Model & Reasoning", fields: MODEL_REASONING_FIELDS },
  { id: "caching", category: "Intelligence", label: "Caching", fields: CACHING_FIELDS },
  { id: "turnDetection", category: "Intelligence", label: "Turn Detection & Timing", fields: TURN_DETECTION_FIELDS },
  { id: "voiceSpeech", category: "Intelligence", label: "Voice & Speech", fields: VOICE_SPEECH_FIELDS },
  { id: "knowledgeBase", category: "Knowledge & Launch", label: "Knowledge Base", fields: [] },
  {
    id: "review",
    category: "Knowledge & Launch",
    label: "Review & Publish",
    fields: [
      ...SETUP_FIELDS,
      ...BUSINESS_HOURS_FIELDS,
      ...MULTI_AGENT_FIELDS,
      ...GREETING_FIELDS,
      ...IVR_FIELDS,
      ...CALL_BEHAVIOR_FIELDS,
      ...LANGUAGES_FIELDS,
      ...SUMMARY_PARAMS_FIELDS,
      ...MODEL_REASONING_FIELDS,
      ...CACHING_FIELDS,
      ...TURN_DETECTION_FIELDS,
      ...VOICE_SPEECH_FIELDS,
    ],
  },
];

export const PROMPT_HUB_SECTION_CATEGORIES = [
  "Setup",
  "Conversation",
  "Intelligence",
  "Knowledge & Launch",
];

export const findPromptHubSection = (sectionId) =>
  PROMPT_HUB_SECTIONS.find((section) => section.id === sectionId);
